import BaseMystery from '../BaseMystery'

const ThirdGloriousMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bastiani/tapestry.jpg",
		"https://www.wga.hu/art/b/barnaba/fragmen1.jpg",
		"https://www.wga.hu/art/a/asam/cosmas/assuvirg.jpg",
		"https://www.wga.hu/art/a/andrea/firenze/spanish/5vault3.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/crown_v/cro_v_8.jpg",
		"https://www.wga.hu/art/d/dyck_van/3other/pentecos.jpg",
		"https://www.wga.hu/art/g/gaddi/taddeo/panels/quatref1.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris23.jpg",
		"https://www.wga.hu/art/g/giotto/z_panel/3polypty/7penteco.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/upper/new_test/01pentec.jpg",
		"https://www.wga.hu/art/g/greco_el/12/1214grec.jpg",
		"https://www.wga.hu/art/j/jacopo/cione/1/3r2_up2.jpg",
		"https://www.wga.hu/art/j/juan/1/lazarus4.jpg",
		"https://www.wga.hu/art/m/mildorfe/mildorf2.jpg",
		"https://www.wga.hu/art/zgothic/mosaics/6sanmarc/2cuwest2.jpg",
		"https://www.wga.hu/art/m/multsche/wurzach/7pentec.jpg",
		"https://www.wga.hu/art/o/orcagna/2/altarpi2.jpg",
		"https://www.wga.hu/art/r/restout/jean2/pentecos.jpg",
		"https://www.wga.hu/art/zzdeco/1gold/12c/01f_1100.jpg",
	];

	const scriptureQuote = "\"Therefore let the whole house of Israel know for certain that God has made him both Lord and Messiah, this Jesus whom you crucified.\"";
	const scriptureCitation = "Acts 2:36 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Acts%202%3A1-41&version=NABRE";

	return (
		<BaseMystery titleText="The Descent of the Holy Spirit"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default ThirdGloriousMystery;